import { preloadImage, asyncTimeout } from '@utils/common';
import { ComponentFrameworkContextMenu } from '@utils/component-framework';
import { generatePrintCss } from '../root.content/organism.print/_print.root.style.js';
import '@i-ark/models';
import 'react';
import { useShareEntryMutation } from '../state/mutations/share-entry.js';
import { selectPrintOrientation } from '../state/selectors/print.get-orientation.js';
import { iArkStore } from '../state/store.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function IArkContextMenu(props) {
  const dispatch = iArkStore.useDispatch();
  const shareEntryWithTeacherMutation = useShareEntryMutation();
  const printOrientation = iArkStore.useSelector(selectPrintOrientation);
  const printCss = generatePrintCss(printOrientation);
  const entryKey = iArkStore.useSelector(state => state.entryKey);
  const onShareWithTeacher = () => {
    props.onButtonClicked?.();
    props.onShareWithTeacher?.();
    shareEntryWithTeacherMutation(entryKey);
  };
  const onBeforePrint = async () => {
    props.onButtonClicked?.();
    const allImages = props.component.data.pages.flatMap(it => it.items).filter(it => it.kind === "image");
    await Promise.all(allImages.map(img => preloadImage(img.src)));
    dispatch(iArkStore.actions.togglePrintLayout(true));
    await asyncTimeout(200);
  };
  const onAfterPrint = () => {
    dispatch(iArkStore.actions.togglePrintLayout(false));
  };
  return /*#__PURE__*/jsxs(ComponentFrameworkContextMenu, {
    className: props.className,
    axis: "horisontal",
    content: "list",
    nodeId: props.nodeId,
    layout: props.layout,
    enabled: props.enabled,
    children: [/*#__PURE__*/jsx(ComponentFrameworkContextMenu.Button, {
      type: "export-legacy",
      componentTitle: props.component.envelope.Title,
      input: {
        ref: props.targetRef
      },
      printCss: printCss,
      printOrientation: printOrientation,
      targets: {
        pdf: true,
        word: false
      },
      hideIrrelevantDOMNodesBeforeExport: true,
      onBeforeExport: onBeforePrint,
      onAfterHTMLSent: onAfterPrint,
      onClick: props.onButtonClicked
    }), /*#__PURE__*/jsx(ComponentFrameworkContextMenu.Button, {
      type: "drive-legacy",
      format: "pdf",
      componentTitle: props.component.envelope.Title,
      entryKey: entryKey,
      input: {
        ref: props.targetRef
      },
      printCss: printCss,
      printOrientation: printOrientation,
      onClick: props.onButtonClicked,
      onBeforeExport: onBeforePrint,
      onAfterHTMLSent: onAfterPrint
    }), /*#__PURE__*/jsx(ComponentFrameworkContextMenu.Button, {
      type: "legacy-print",
      printCss: printCss,
      onClick: props.onButtonClicked,
      onBeforePrint: onBeforePrint,
      onAfterPrint: onAfterPrint,
      targetRef: props.targetRef
    }), /*#__PURE__*/jsx(ComponentFrameworkContextMenu.Button, {
      type: "share",
      entryKey: entryKey,
      componentId: props.component.envelope.ID,
      onClick: props.onButtonClicked,
      onShareWithTeacher: onShareWithTeacher
    }), props.children]
  });
}

export { IArkContextMenu };
//# sourceMappingURL=integration.context-menu.js.map
